module.exports = __webpack_public_path__ + "static/contact-1bcf6815d88f4d7aa803e44620b7990a.svg";